<template>
  <wa-page view-slug="icon-pack-hidden">
    <wa-page-header
      slot="header"
      key="header"
    />

    <icon-pack-disabled slot="content" />

    <wa-page-footer slot="footer" />
  </wa-page>
</template>

<script>
  import IconPackDisabled from '../IconPackDisabled'

  export default {
    name: 'TemplateHidden',
    components: {
      IconPackDisabled
    }
  }
</script>
